const ERROR_MESSAGE_CLASS = 'cb-field-error';

const isFieldRequired = (element) => (
  element.hasAttribute('required')
  || element.getAttribute('data-required') === 'true'
  || element.getAttribute('aria-required') === 'true'
);

const getFieldLabel = (element) => {
  const ariaLabel = element.getAttribute('aria-label');
  if (ariaLabel) return ariaLabel.trim();

  const label = element.closest('label');
  if (label) {
    const clone = label.cloneNode(true);
    clone.querySelectorAll('input, textarea, select').forEach((input) => input.remove());
    clone.querySelectorAll(`.${ERROR_MESSAGE_CLASS}`).forEach((error) => error.remove());
    const text = clone.textContent.replace(/\s+/g, ' ').trim();
    if (text) return text;
  }

  const placeholder = element.getAttribute('placeholder');
  if (placeholder) return placeholder.trim();

  if (element.name) {
    return element.name
      .replace(/([A-Z])/g, ' $1')
      .replace(/[_-]+/g, ' ')
      .trim()
      .replace(/^\w/, (char) => char.toUpperCase());
  }

  return 'This field';
};

const isTextLikeInput = (element) => {
  const type = (element.type || 'text').toLowerCase();
  return type !== 'checkbox' && type !== 'radio' && type !== 'file' && type !== 'button' && type !== 'submit';
};

const isFieldEmpty = (element) => {
  const tagName = element.tagName.toLowerCase();
  const type = (element.type || '').toLowerCase();

  if (type === 'checkbox') {
    return !element.checked;
  }

  if (type === 'radio') {
    const groupName = element.name;
    if (!groupName) return !element.checked;
    const group = element.ownerDocument.getElementsByName(groupName);
    return !Array.from(group).some((radio) => radio.checked);
  }

  if (tagName === 'select') {
    return !String(element.value || '').trim();
  }

  if (isTextLikeInput(element)) {
    return !String(element.value || '').trim();
  }

  return false;
};

const markFieldError = (element, message) => {
  const parent = element.closest('label') || element.parentElement;
  if (!parent || parent.querySelector(`.${ERROR_MESSAGE_CLASS}`)) return;

  const errorEl = element.ownerDocument.createElement('p');
  errorEl.className = ERROR_MESSAGE_CLASS;
  errorEl.textContent = message;
  errorEl.style.cssText = 'margin: 4px 0 0; color: #ef4444; font-size: 12px;';
  parent.appendChild(errorEl);
};

export const clearMembershipFormValidation = (doc) => {
  if (!doc) return;

  doc.querySelectorAll(`.${ERROR_MESSAGE_CLASS}`).forEach((element) => element.remove());
};

export const validateMembershipForm = (doc) => {
  if (!doc) {
    return { valid: true, errors: [], firstInvalidField: null };
  }

  clearMembershipFormValidation(doc);

  const candidates = Array.from(doc.querySelectorAll('input, textarea, select'))
    .filter((element) => !element.disabled && element.type !== 'hidden');

  const requiredFields = candidates.filter(isFieldRequired);
  const validatedRadioGroups = new Set();
  const errors = [];
  let firstInvalidField = null;

  requiredFields.forEach((element) => {
    const type = (element.type || '').toLowerCase();

    if (type === 'radio') {
      const groupName = element.name || element.id || '__ungrouped__';
      if (validatedRadioGroups.has(groupName)) return;
      validatedRadioGroups.add(groupName);
    }

    if (!isFieldEmpty(element)) return;

    const message = `${getFieldLabel(element)} is required`;
    markFieldError(element, message);
    errors.push({ element, message });

    if (!firstInvalidField) {
      firstInvalidField = element;
    }
  });

  return {
    valid: errors.length === 0,
    errors,
    firstInvalidField
  };
};
